import { Ref, ref } from 'vue';

type ToastType = 'success' | 'error' | 'warning' | 'info';

const isOpen: Ref<boolean> = ref(false);
const type = ref<ToastType>('info');
const title = ref<string>('');
const message = ref<string>('');
const useToast = () => {
  isOpen.value = false;

  const toast = (theMessage: string, theType: ToastType = 'info', theTitle: string = '') => {
    type.value = theType;
    message.value = theMessage;
    title.value = theTitle;

    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  return {
    isOpen,
    message,
    title,
    type,
    toast,
    close,
  };
};

export default useToast;
